import React from "react";
import { CheckCircle, Circle, PlayCircle } from "lucide-react";
import { Button } from "./Button";

/**
 * Client-portal milestone card. Used in the light-refined executive theme.
 * @param {Object} props
 * @param {string} props.projectName
 * @param {string} props.address
 * @param {Array<{label:string,date:string,status:"complete"|"in_progress"|"upcoming"}>} props.milestones
 * @param {()=>void} [props.onApprove]
 * @param {()=>void} [props.onRequestChanges]
 */
export function ClientMilestoneCard({
  projectName, address, milestones = [], onApprove, onRequestChanges,
}) {
  return (
    <div className="ds-client-card">
      <div className="type-caption">Client portal · milestone view</div>
      <div className="ds-ph-title" style={{ fontSize: 20, marginTop: 4 }}>{projectName}</div>
      <div className="ds-ph-address">{address}</div>
      <div className="ds-milestones">
        {milestones.map((m) => (
          <div key={m.label} className={`ds-milestone is-${m.status.replace("_", "-")}`}>
            <span className="ds-m-dot">
              {m.status === "complete" && <CheckCircle size={12} color="var(--color-canvas)" />}
              {m.status === "in_progress" && <PlayCircle size={12} color="var(--color-canvas)" />}
              {m.status === "upcoming" && <Circle size={12} color="var(--color-text-muted)" />}
            </span>
            <span>{m.label}</span>
            <span className="ds-m-date">{m.date}</span>
          </div>
        ))}
      </div>
      {(onApprove || onRequestChanges) && (
        <div className="btn-row" style={{ marginTop: 16 }}>
          {onApprove && <Button size="sm" onClick={onApprove}>Approve milestone</Button>}
          {onRequestChanges && <Button variant="ghost" size="sm" onClick={onRequestChanges}>Request changes</Button>}
        </div>
      )}
    </div>
  );
}
